import * as tslib_1 from "tslib";
import { action, observable, computed } from "mobx";
export var DeviceType;
(function (DeviceType) {
    DeviceType["desktop"] = "IsDesktop";
    DeviceType["mobile"] = "IsMobile";
    DeviceType["tablet"] = "IsTablet";
})(DeviceType || (DeviceType = {}));
export var DeviceOrientation;
(function (DeviceOrientation) {
    DeviceOrientation["landscape"] = "landscape-orientation";
    DeviceOrientation["portrait"] = "portrait-orientation";
    DeviceOrientation["desktop"] = "desktop-orientation";
})(DeviceOrientation || (DeviceOrientation = {}));
var DeviceDetect = /** @class */ (function () {
    function DeviceDetect() {
        if (!DeviceDetect._instance) {
            DeviceDetect._instance = this;
        }
        this.eventsManager = new EventsManager();
        this.deviceOrientation = DeviceOrientation.portrait;
        this.deviceType = DeviceType.mobile;
        var app = window["Application"];
        if (typeof app !== "undefined" && typeof app.deviceType !== "undefined" && typeof app.deviceType.type !== "undefined") {
            this.deviceType = app.deviceType.type;
        }
        if (typeof app !== "undefined" && typeof app.deviceOrientation !== "undefined" && typeof app.deviceOrientation.orientation !== "undefined") {
            this.deviceOrientation = app.deviceOrientation.orientation;
        }
        this.eventsManager.addEventListener("onDeviceOrientationChange", this, this.onDeviceOrientationChange, true);
        this.eventsManager.addEventListener("onDeviceTypeChange", this, this.onDeviceTypeChange, true);
        this.isIOS = false;
        this.checkIOS();
    }
    DeviceDetect.getInstance = function () {
        return DeviceDetect._instance || new DeviceDetect();
    };
    Object.defineProperty(DeviceDetect.prototype, "isDesktop", {
        get: function () {
            return this.deviceType === DeviceType.desktop;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DeviceDetect.prototype, "isMobile", {
        get: function () {
            return this.deviceType === DeviceType.mobile;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DeviceDetect.prototype, "isTablet", {
        get: function () {
            return this.deviceType === DeviceType.tablet;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DeviceDetect.prototype, "isLandscape", {
        get: function () {
            return this.deviceOrientation === DeviceOrientation.landscape;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DeviceDetect.prototype, "isPortrait", {
        get: function () {
            return this.deviceOrientation === DeviceOrientation.portrait;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DeviceDetect.prototype, "deviceTypeValue", {
        get: function () {
            return this.deviceType;
        },
        enumerable: true,
        configurable: true
    });
    DeviceDetect.prototype.onDeviceOrientationChange = function (orientation) {
        this.deviceOrientation = orientation;
    };
    DeviceDetect.prototype.onDeviceTypeChange = function (type) {
        this.deviceType = type;
    };
    DeviceDetect.prototype.checkIOS = function () {
        this.isIOS = /iPad|iPhone|iPod/i.test(navigator.userAgent) ? true : false;
    };
    tslib_1.__decorate([
        observable,
        tslib_1.__metadata("design:type", String)
    ], DeviceDetect.prototype, "deviceOrientation", void 0);
    tslib_1.__decorate([
        observable,
        tslib_1.__metadata("design:type", String)
    ], DeviceDetect.prototype, "deviceType", void 0);
    tslib_1.__decorate([
        computed,
        tslib_1.__metadata("design:type", Object),
        tslib_1.__metadata("design:paramtypes", [])
    ], DeviceDetect.prototype, "isDesktop", null);
    tslib_1.__decorate([
        computed,
        tslib_1.__metadata("design:type", Object),
        tslib_1.__metadata("design:paramtypes", [])
    ], DeviceDetect.prototype, "isMobile", null);
    tslib_1.__decorate([
        computed,
        tslib_1.__metadata("design:type", Object),
        tslib_1.__metadata("design:paramtypes", [])
    ], DeviceDetect.prototype, "isTablet", null);
    tslib_1.__decorate([
        computed,
        tslib_1.__metadata("design:type", Object),
        tslib_1.__metadata("design:paramtypes", [])
    ], DeviceDetect.prototype, "isLandscape", null);
    tslib_1.__decorate([
        computed,
        tslib_1.__metadata("design:type", Object),
        tslib_1.__metadata("design:paramtypes", [])
    ], DeviceDetect.prototype, "isPortrait", null);
    tslib_1.__decorate([
        computed,
        tslib_1.__metadata("design:type", Object),
        tslib_1.__metadata("design:paramtypes", [])
    ], DeviceDetect.prototype, "deviceTypeValue", null);
    tslib_1.__decorate([
        action.bound,
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [String]),
        tslib_1.__metadata("design:returntype", void 0)
    ], DeviceDetect.prototype, "onDeviceOrientationChange", null);
    tslib_1.__decorate([
        action.bound,
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [String]),
        tslib_1.__metadata("design:returntype", void 0)
    ], DeviceDetect.prototype, "onDeviceTypeChange", null);
    tslib_1.__decorate([
        action.bound,
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", []),
        tslib_1.__metadata("design:returntype", void 0)
    ], DeviceDetect.prototype, "checkIOS", null);
    return DeviceDetect;
}());
export { DeviceDetect };
//# sourceMappingURL=DeviceDetect.js.map